import React, { Fragment } from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import Scrollbar from 'react-scrollbars-custom';
import {
  Router,
  withRouter,
  Route,
  Switch
} from 'react-router-dom';
import FastClick from 'fastclick';
import './polyfills';
import history from "./history.js";
import './helpers/disableTouchScroll';
import config from './config';


import lang from './lang';
import Defines from './Defines';
import './assets/css/main.scss';
import store from './store';

import Auth from './components/auth';
import Home from './components/routes/Home';
import Economy from './components/routes/Economy';
import EconomyOverview from './components/routes/EconomyOverview';
import Login from './components/routes/Login';
import Ministries from './components/routes/Ministries';
import Ministry from './components/routes/Ministry';
import MinistryBudget from './components/routes/MinistryBudget';
import FeedbackOverview from './components/routes/FeedbackOverview';
import Feedback from './components/routes/Feedback';
import Taxes from './components/routes/Taxes';
import Bank from './components/routes/Bank';
import Verdienen from './components/routes/Verdienen';
import Verdelen from './components/routes/Verdelen';
import Beleidskeuzes from './components/routes/Beleidskeuzes';
import Prepare from './components/routes/Prepare';
import GameInfo from './components/routes/GameInfo';
import GamePage from './components/routes/GamePage';
import Vimeo from './components/routes/Vimeo';
import Drive from './components/routes/Drive';
import Video from './components/routes/Video';
import Audio from './components/routes/Audio';
import Password from './components/routes/Password';

import GroupPortalHome from './components/routes/GroupPortalHome';
import ClassLeaderPortalHome from './components/routes/ClassLeaderPortalHome';
import PortalRedirect from './components/portalRedirect';
import TeamInfo from './components/routes/TeamInfo';
import Rankings from './components/routes/Rankings';
import BonusPoints from './components/routes/BonusPoints';
import ClassBonusPoints from './components/routes/ClassBonusPoints';
import ClassLeaderMedia from './components/routes/ClassLeaderMedia';

import Header from './components/elements/Header';
import BudgetHeader from './components/elements/StepThree/BudgetHeader';
import TopBar from './components/elements/TopBar';
import PopupContainer from './components/elements/PopupContainer';
import ToggleFullscreen from './components/elements/ToggleFullscreen';
import HideDesktopMobileContents from './components/elements/HideDesktopMobileContents';

import Desktop from './components/routes/Desktop';
import DesktopMinistries from './components/desktop/Ministries';
import DesktopFeedback from './components/desktop/Feedback';
import DekstopTaxes from './components/desktop/Taxes';
import DekstopTaxesMain from './components/desktop/TaxesMain';
import DesktopMinistryBudget from './components/desktop/MinistryBudget';
import DesktopBeleidskeuzes from './components/desktop/Beleidskeuzes';
import DesktopGroupPortalHome from './components/desktop/GroupPortalHome';
import DesktopTeamInfo from './components/desktop/TeamInfo';
import SchoolPortalHome from './components/desktop/SchoolPortalHome';
import SchoolPortalClass from './components/desktop/SchoolPortalClass';
import SchoolPortalTest from './components/desktop/SchoolPortalTest';
import SchoolPortalMedia from './components/desktop/SchoolPortalMedia';
import PreparePublic from './components/routes/PreparePublic';
import EscapeRoute from './components/routes/EscapeRoute';

import Loading from './components/elements/Loading';
import {cookie} from "glxl-helpers";

const desktop = document.querySelector('#root').clientWidth >= 1240;

if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function() {
      FastClick.attach(document.body);
  }, false);
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      sessionStorage.setItem('prevLocation', prevProps.location.pathname);
    }
  }

  componentWillUnmount () {
    if (window.socket && window.socket.close) {
      window.socket.close();
      window.socket = null;
    }
    if (window.timerId) {
      clearTimeout(window.timerId);
    }
  }

  componentWillReceiveProps(props) {
    if (props.location.pathname !== this.prevPath) {
      window.scrollTo(0, 0);
    }
    this.prevPath = props.location.pathname;
  }

  componentDidMount() {
    const dontRedirect = window.location.pathname.startsWith('/portal/school/voorbereiding') || window.location.pathname.startsWith('/portal/password');
    window.onmessage = (e) => {
      if(
        ['schoolcontact', 'classleader'].includes(e.data)
        && !(sessionStorage.getItem('noMobile') === 'true')
      ) {
        sessionStorage.setItem('noMobile', 'true');
        if (!dontRedirect) {
          if (e.data === 'schoolcontact') {
            history.push('/portal/school');
          } else if (e.data === 'classleader') {
            history.push('/portal/classleader');
          }
        }
        this.setState({schoolcontact: true});
      }

      if(
        ['groupmember'].includes(e.data)
        && !(sessionStorage.getItem('noMobile') === 'false')
      ) {
        if(history.location.pathname.indexOf('teaminfo') === -1) {
          sessionStorage.setItem('noMobile', 'false');
          if (!dontRedirect) {
            history.push('/');
          }
        }
      }
      if(
        ['groupmember-leader'].includes(e.data)
        && !(sessionStorage.getItem('noMobile') === 'false')
      ) {
        const redirect = sessionStorage.getItem('redirect');
        if(redirect) {
          sessionStorage.setItem('noMobile', 'true');

          sessionStorage.removeItem('redirect');
          if (!dontRedirect) {
            console.log("REDIRECTING TO ", redirect);
            history.push(redirect);
          }
        }
      }
    };

    this.setState({
      isLoading: false
    });
  }

  renderDesktop() {
    return (
      <div className={'page-content desktop'}>
        <Router history={history}>
          <Fragment>
            <Route path="/login" component={Login} />
            <Route exact path="/blank" component={() => null} />

            <Route render={({location}) => {
              return location.pathname.match( /(\/login|\/portal|\/escaperoute)/ ) ? '' : <Route component={Auth(Header, ['groupleader', 'groupmember'], null, { "desktop": true })} />
            }} />

            <Route render={({location}) => {
              if (location.pathname.startsWith('/portal/school/voorbereiding')) return null;
              if (location.pathname.startsWith('/portal/vimeo')) return null;
              if (location.pathname.startsWith('/portal/drive')) return null;
              if (location.pathname.startsWith('/portal/video')) return null;
              if (location.pathname.startsWith('/portal/audio')) return null;
              if (location.pathname.startsWith('/portal/password')) return null;
              return location.pathname.indexOf('portal') !== -1 || location.pathname.indexOf('escaperoute') !== -1 ? <Route component={Auth(TopBar, ['groupleader', 'groupmember', 'classleader'], null, { "desktop": true })} /> : ''
            }} />

            {/* In simulation game games */}
            <Route exact path="/escaperoute" component={Auth(EscapeRoute, ['groupleader', 'groupmember', 'classleader'], null, { "desktop": true })} />

            <Route exact path="/portal" component={Auth(PortalRedirect)} />
            <Route exact path="/portal/classleader" component={Auth(ClassLeaderPortalHome, ['classleader'], null, { "desktop": true })} />
            <Route exact path="/portal/classleader/verdelen" component={Auth(Verdelen, ['classleader'], null, { "desktop": true })} />
            <Route exact path="/portal/classleader/prepare" component={Auth(Prepare, ['classleader'], null, { "desktop": true })} />
            <Route exact path="/portal/classleader/prepare/:startup" component={Auth(Prepare, ['classleader'], null, { "desktop": true })} />
            <Route exact path="/portal/classleader/teaminfo/:groupId" component={Auth(DesktopTeamInfo, ['classleader'], null, { "desktop": true })} />
            <Route exact path="/portal/classleader/verdienen/:gameId" component={Auth(Verdienen, ['classleader'], null, { "desktop": true })} />
            <Route path="/portal/classleader/media" component={Auth(ClassLeaderMedia, ['classleader'])} />
            <Route exact path="/portal/classleader/bonuspoints" component={Auth(BonusPoints, ['classleader'], null, { "desktop": true })} />
            <Route path="/portal/vimeo/:vimeoId" component={Vimeo} />
            <Route path="/portal/drive" component={Drive} />
            <Route path="/portal/video/:videoId" component={Video} />
            <Route path="/portal/audio/:audioId" component={Audio} />
            <Route path="/portal/password/:generalMaterialId" component={(props) => <Password {...props} desktop />} />
            <Route exact path="/portal/group" component={Auth(DesktopGroupPortalHome, ['groupleader', 'groupmember'], null, { "desktop": true })} />
            <Route exact path="/portal/gameinfo/:gameid" component={Auth(GameInfo, ['groupleader', 'groupmember'], null, { "desktop": true })} />
            <Route exact path="/portal/game/:gameid" component={Auth(GamePage, ['groupleader', 'groupmember'], null, { "desktop": true })} />
            <Route exact path="/portal/teaminfo" component={Auth(DesktopTeamInfo, ['groupleader', 'groupmember'])} />
            <Route exact path="/portal/bonuspoints" component={Auth(ClassBonusPoints, ['groupleader', 'groupmember'], null, { "desktop": true })} />
            <Route exact path="/portal/school" component={Auth(SchoolPortalHome, ['schoolcontact'])} />
            <Route exact path="/portal/school/class/:action" component={Auth(SchoolPortalClass, ['schoolcontact'])} />
            <Route exact path="/portal/school/test" component={Auth(SchoolPortalTest, ['schoolcontact'])} />
            <Route exact path="/portal/school/media/:projectId" component={Auth(SchoolPortalMedia, ['schoolcontact'])} />
            <Route exact path="/portal/school/prepare" component={Auth(Prepare, ['schoolcontact'], null, { "desktop": true, "schoolcontact": true })} />
            <Route exact path="/portal/school/voorbereiding/:projectId/:languageId?/:difficultyId?" component={PreparePublic} />
            <Route exact path="/portal/rankings/:projectId" component={Auth(Rankings, ['groupleader', 'groupmember', 'classleader'], null, { "desktop": true })} />
            <Route exact path="/portal/rankings/:projectId/:schoolClassId" component={Auth(Rankings, ['groupleader', 'groupmember', 'classleader'], null, { "desktop": true })} />

            <Route render={({location}) => {
              if (location.pathname.startsWith('/portal')) {
                document.body.classList.add('portalPage');
              } else {
                document.body.classList.remove('portalPage');
              }
              if (location.pathname.startsWith('/portal')) return null;
              return (
                <div className={`desktopcontainer ${(location.pathname.startsWith('/taxes') ? 'taxes-main-container' : '')}`}>
                  <div className={'split-container'}>
                    <div className={'sidebar'}>
                      <Route exact path={'/(|ministries|bank)/'} component={Auth(BudgetHeader, ['groupleader', 'groupmember'], [3], { "desktop": true, "redirect": false })}/>
                      <Route exact path={'/ministries/budget/:id'} component={Auth(BudgetHeader, ['groupleader', 'groupmember'], [3], { "desktop": true, "redirect": false })}/>
                      <Route exact path={'/ministries/:id/:feedbackIdentifier/:effect?/:ministryId?'} component={Auth(BudgetHeader, ['groupleader', 'groupmember'], [3], { "desktop": true, "redirect": false })}/>
                      <Route exact path={'/beleidskeuzes/:beleidskeuze?'} component={Auth(BudgetHeader, ['groupleader', 'groupmember'], [3], { "desktop": true, "redirect": false })} />

                      <Scrollbar noScrollX style={ {width: '100%', height: '100%', minHeight: 300} } >
                        <Switch>
                          <Route exact path={'/economy/:id'} component={Auth(DesktopMinistries, ['groupleader', 'groupmember'], [1, 3])} />

                          <Route exact path={'/(|ministries|bank)/'} component={Auth(DesktopMinistries, ['groupleader', 'groupmember'], [1, 3])}/>
                          <Route exact path={'/ministries/:id'} component={Auth(DesktopMinistries, ['groupleader', 'groupmember'], [1, 3])} />
                          <Route exact path={'/ministries/overview/:type'} component={Auth(DesktopMinistries, ['groupleader', 'groupmember'], [1, 3])}/>
                          <Route exact path={'/ministries/budget/:id'} component={Auth(DesktopMinistries, ['groupleader', 'groupmember'], [3])} />
                          <Route exact path={'/ministries/:id/:feedbackIdentifier/:effect?/:ministryId?'} component={Auth(DesktopMinistries, ['groupleader', 'groupmember'], [1, 3])}/>

                          <Route exact path={'/beleidskeuzes/:beleidskeuze?'} component={Auth(DesktopMinistries, ['groupleader', 'groupmember'], [1, 3])} />
                          <Route exact path={'/beleidskeuzes/:id/:feedbackIdentifier'} component={Auth(DesktopMinistries, ['groupleader', 'groupmember'], [1, 3])} />

                          <Route exact path={'/taxes/:taxid?'} component={Auth(DekstopTaxes, ['groupleader', 'groupmember'], [2], { "desktop": true })} />
                        </Switch>
                      </Scrollbar>

                      { !this.state.isLoading ? (
                        <div className="fullscreen-wrapper">
                          <ToggleFullscreen />
                        </div>
                      ) : null }
                    </div>
                    <div className={'main'}>
                      <Switch>
                        <Route exact path={'/economy/:id'} component={Auth(Desktop, ['groupleader', 'groupmember'], [1, 3])}/>

                        <Route exact path={'/(|ministries)/'} component={Auth(Desktop, ['groupleader', 'groupmember'], [1, 3])}/>
                        <Route exact path={'/ministries/:id'} component={Auth(Desktop, ['groupleader', 'groupmember'], [1, 3])} />

                        <Route exact path={'/ministries/overview/basic/:type/:identifier?'} component={Auth(DesktopFeedback, ['groupleader', 'groupmember'], [1, 3])}/>
                        <Route exact path={'/ministries/overview/:type'} component={Auth(Desktop, ['groupleader', 'groupmember'], [1, 3])}/>

                        <Route exact path={'/ministries/budget/:id'} component={Auth(DesktopMinistryBudget, ['groupleader', 'groupmember'], [3])} />
                        <Route exact path={'/ministries/:id/:feedbackIdentifier/:effect?/:ministryId?'} component={Auth(DesktopFeedback, ['groupleader', 'groupmember'], [1, 3])}/>

                        <Route exact path={'/beleidskeuzes'} component={Auth(Desktop, ['groupleader', 'groupmember'], [1, 3])} />
                        <Route exact path={'/beleidskeuzes/:beleidskeuze'} component={Auth(DesktopBeleidskeuzes, ['groupleader', 'groupmember'], [1, 3])} />
                        <Route exact path={'/beleidskeuzes/:id/:feedbackIdentifier'} component={Auth(DesktopFeedback, ['groupleader', 'groupmember'], [1, 3])} />

                        <Route exact path={'/taxes'} component={Auth(Desktop, ['groupleader', 'groupmember'], [2], { "desktop": true })} />
                        <Route exact path={'/taxes/:taxid'} component={Auth(DekstopTaxesMain, ['groupleader', 'groupmember'], [2])} />
                        <Route exact path={"/bank"} component={Auth(Bank, ['groupleader', 'groupmember'], [3], { "desktop": true })} />
                      </Switch>
                    </div>
                  </div>
                </div>
              );
            }} />

          </Fragment>
        </Router>
        <PopupContainer/>
        <HideDesktopMobileContents/>
      </div>
    )
  }

  renderMobile() {
    return (
      <div className={'page-content'}>
        <Router history={history}>
          <Fragment>
            <Route render={({location}) => {
              if (location.pathname.startsWith('/portal')) document.body.classList.add('portalPage');
              if (location.pathname.startsWith('/login')) { return null; }
              if (location.pathname.startsWith('/portal/video')) { return null; }
              if (location.pathname.startsWith('/portal/vimeo')) { return null; }
              if (location.pathname.startsWith('/portal/drive')) { return null; }
              if (location.pathname.startsWith('/portal/audio')) { return null; }
              if (location.pathname.startsWith('/portal/password')) { return null; }
              return <TopBar />;
            }} />
            <Switch>
              <Route exact path="/login" component={Login} />
              <Route exact path="/blank" component={() => null} />
              <Route exact path="/" component={Auth(Home, ['groupleader', 'groupmember'], [1, 3])} />

              {/* In simulation game games */}
              <Route exact path="/escaperoute" component={Auth(EscapeRoute, ['groupleader', 'groupmember', 'classleader'])} />

              {/* Dynamic: displaying actual content. */}
              <Route exact path="/economy" component={Auth(EconomyOverview, ['groupleader', 'groupmember'], [1, 2, 3])} />
              <Route exact path="/ministries" component={Auth(Ministries, ['groupleader', 'groupmember'], [1, 3])} />
              <Route exact path="/ministries/:id" component={Auth(Ministry, ['groupleader', 'groupmember'], [1, 3])} />
              <Route exact path="/ministries/overview/:type/:id?" component={Auth(FeedbackOverview, ['groupleader', 'groupmember'], [1, 3])} />
              <Route exact path="/ministries/overview/:type/:id/:feedbackIdentifier" component={Auth(Feedback, ['groupleader', 'groupmember'], [1, 3])} />
              <Route exact path="/ministries/budget/:id" component={Auth(MinistryBudget, ['groupleader', 'groupmember'], [3])} />
              <Route exact path="/ministries/:id/:feedbackIdentifier/:effect?/:ministryId?" component={Auth(Feedback, ['groupleader', 'groupmember'], [1, 3])} />

              {/* Static: displaying dummy content. */}
              <Route exact path="/economy/:id" component={Auth(Economy, ['groupleader', 'groupmember'], [1, 3])} />
              <Route exact path="/taxes" component={Auth(Taxes, ['groupleader', 'groupmember'], [2])} />
              <Route exact path={'/taxes/:taxid'} component={Auth(Taxes, ['groupleader', 'groupmember'], [2])} />

              <Route exact path="/bank" component={Auth(Bank, ['groupleader', 'groupmember'], [3])} />
              <Route exact path="/beleidskeuzes" component={Auth(Beleidskeuzes, ['groupleader', 'groupmember'], [1, 3])} />
              <Route exact path="/beleidskeuzes/:id/:feedbackIdentifier" component={Auth(Feedback, ['groupleader', 'groupmember'], [1, 3])} />

              {/* Unsorted pages */}
              <Route exact path="/portal" component={Auth(PortalRedirect)} />
              <Route exact path="/portal/group" component={Auth(GroupPortalHome, ['groupleader', 'groupmember'])} />
              <Route exact path="/portal/gameinfo/:gameid" component={Auth(GameInfo, ['groupleader', 'groupmember'])} />
              <Route exact path="/portal/game/:gameid" component={Auth(GamePage, ['groupleader', 'groupmember'])} />
              <Route exact path="/portal/teaminfo" component={Auth(TeamInfo, ['groupleader', 'groupmember'])} />
              <Route exact path="/portal/bonuspoints" component={Auth(ClassBonusPoints, ['groupleader', 'groupmember'])} />
              <Route exact path="/portal/classleader" component={Auth(ClassLeaderPortalHome, ['classleader'])} />
              <Route exact path="/portal/classleader/teaminfo/:groupId" component={Auth(TeamInfo, ['classleader'])} />
              <Route exact path="/portal/classleader/verdienen/:gameId" component={Auth(Verdienen, ['classleader'])} />
              <Route exact path="/portal/classleader/verdelen" component={Auth(Verdelen, ['classleader'])} />
              <Route exact path="/portal/classleader/prepare" component={Auth(Prepare, ['classleader'])} />
              <Route exact path="/portal/classleader/prepare/:startup" component={Auth(Prepare, ['classleader'])} />

              <Route exact path="/portal/school" component={Auth(SchoolPortalHome, ['schoolcontact'])} />
              <Route exact path="/portal/school/class/:action" component={Auth(SchoolPortalClass, ['schoolcontact'])} />
              <Route exact path="/portal/school/test" component={Auth(SchoolPortalTest, ['schoolcontact'])} />
              <Route exact path="/portal/school/media/:projectId" component={Auth(SchoolPortalMedia, ['schoolcontact'])} />
              <Route exact path="/portal/school/prepare" component={Auth(Prepare, ['schoolcontact'], null, {"schoolcontact": true })} />
              <Route exact path="/portal/school/voorbereiding/:projectId/:languageId?/:difficultyId?" component={PreparePublic} />

              <Route path="/portal/vimeo/:vimeoId" component={Vimeo} />
              <Route path="/portal/drive/" component={Drive} />
              <Route path="/portal/video/:videoId" component={Video} />
              <Route path="/portal/audio/:audioId" component={Audio} />
              <Route path="/portal/password/:generalMaterialId" component={Password} />
              <Route path="/portal/classleader/bonuspoints" component={Auth(BonusPoints, ['classleader'])} />
              <Route path="/portal/classleader/media" component={Auth(ClassLeaderMedia, ['classleader'])} />

              <Route exact path="/portal/rankings/:projectId" component={Auth(Rankings, ['groupleader', 'groupmember', 'classleader'])} />
              <Route exact path="/portal/rankings/:projectId/:schoolClassId" component={Auth(Rankings, ['groupleader', 'groupmember', 'classleader'])} />
            </Switch>
            <HideDesktopMobileContents/>
          </Fragment>
        </Router>
        <PopupContainer/>
      </div>
    )
  }

  render () {
    let redirect = (new URL(window.location));
    redirect = redirect.searchParams.get('redirect');

    if(redirect && redirect.length > 0){
      sessionStorage.setItem('redirect', redirect);
    }
    if (this.state.isLoading) {
      return <Loading />;
    }
    if (desktop) {
      if(config.disableDesktop === 'true' && !(sessionStorage.getItem('noMobile') === 'true')) {
        document.body.classList.add('desktopDisabled');

        let alternatePath = this.props.location.pathname+this.props.location.search;

        if(cookie.getCookie('token') || (alternatePath !== '/' &&  alternatePath !== '/login')) {
          let path = '/';
          if(alternatePath.indexOf('token') > -1) {
            path = alternatePath;
          } else if(cookie.getCookie('token') && cookie.getCookie('token') !== false) {
            path = '/';
          } else {
            path = alternatePath;
          }
          return (
            <div className={'fakePhone'}>
              <div className={'phone-frame'}>
                <iframe title="simulatiespel" id="foo" className={'desktopDisabled'} src={path} height="700" width="417"></iframe>
              </div>
            </div>
          )
        }
      }
      return this.renderDesktop();
    } else {
      if(window.top.document.querySelector('html').offsetWidth > 1280){
        return (
          <Scrollbar noScrollX style={ {width: '100%', height: '100%', minHeight: '100vh'} } >
            {this.renderMobile()}
          </Scrollbar>
        )
      }
      return this.renderMobile();
    }
  }
}

const AppRoute = withRouter(App);

Promise.all([lang.init, Defines.fetch()]).then(() => {
  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <AppRoute />
      </Router>
    </Provider>
  , document.getElementById('root'));
});



// WEBPACK FOOTER //
// ./src/index.js